<section *ngIf="storeFinderTowns.length" class="productDetailsSection productDetailsAvailability">
  <h3>{{'productDetails.availability.title' | translate}}</h3>
  <header>
    <p class="productDetailsAvailability__online" >
      <b>{{'productDetails.availability.online' | translate}} {{site}}</b> <span [ngClass]="{'notAvailable': !availableOnline}">{{isAvailable(availableOnline) | translate}}</span>
    </p>
    <div class="productDetailsAvailability__selector">
      <p>
        {{'productDetails.availability.poses' | translate}}
      </p>
      <ng-select (change)="selectTown($event)" [items]="storeFinderTowns" [placeholder]="'cart.poses.select.pos.placeholder' | translate" [notFoundText]="'cart.poses.select.pos.noResults' | translate" class="cartPoses_select_box"></ng-select>
    </div>
  </header>
  <ng-container *ngIf="(poses$|async) as poses">
    <ul *ngIf="poses.length; else unavailable" class="productDetailsAvailability__poses">
      <li *ngFor="let pos of poses">
        <b>{{pos.displayName}}</b>
        <address>
          {{pos.address.street}} <span *ngIf="pos.address.phone"><b>tel.</b> {{pos.address.phone}}</span>
          <ng-container *ngFor="let day of pos.openingHours">
            <p>
              {{day}}
            </p>
          </ng-container>

        </address>
        <span>{{'productDetails.availability.available' | translate}}</span>
      </li>
    </ul>
    <ng-template #unavailable>
      <p class="productDetailsAvailability__unavailability">{{'productDetails.availability.unavailable.text1' | translate}} {{town}} {{'productDetails.availability.unavailable.text2' | translate}}</p>
    </ng-template>
  </ng-container>
</section>
